// Atalhos de forma (espec. 8.3): os três botões e os campos do atalho ativo, mais a
// tradução atalho → perfil. Apresentacional: recebe o formulário e devolve patches;
// a validação e a tabela visível ficam com o `RuleEditorOffcanvas`.
import { bpsToPercentInput, integerInput, percentInputToBps } from "./format";
import {
  MAX_OFFSET,
  MIN_OFFSET,
  downPaymentPlusInstallments,
  equalInstallments,
} from "./profile";

export const SHORTCUTS = Object.freeze([
  { value: "equal", label: "Parcelas iguais" },
  { value: "down_payment", label: "Entrada + parcelas" },
  { value: "custom", label: "Personalizado" },
]);

/** Atalho + formulário → linhas do perfil. Lança `ProfileError` em forma impossível. */
export const buildShortcutProfile = (shortcut, form) => {
  if (shortcut === "equal") {
    return equalInstallments({
      installments: form.installments,
      startOffset: form.startOffset,
    });
  }
  return downPaymentPlusInstallments({
    downPaymentBps: form.downPaymentBps,
    downPaymentOffset: form.downPaymentOffset,
    installments: form.installments,
    startOffset: form.startOffset,
  });
};

// Os limites do validador viram limites do campo: o cliente vê a faixa aceita
// antes de errar, e as setas do input não passam dela.
const OFFSET_RANGE = Object.freeze({ min: String(MIN_OFFSET), max: String(MAX_OFFSET) });

const numberValue = (value) => (Number.isFinite(value) ? value : "");

const RuleShortcutFields = ({ shortcut, form, errorId, onPick, onPatch }) => (
  <>
    <div className="ampli-rule-editor__shortcuts" role="group" aria-label="Atalhos de forma">
      {SHORTCUTS.map((option) => (
        <button
          key={option.value}
          type="button"
          aria-pressed={shortcut === option.value}
          className={shortcut === option.value ? "active" : undefined}
          onClick={() => onPick(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>

    {shortcut === "custom" ? null : (
      <div className="ampli-rule-editor__shortcut-fields">
        {shortcut === "down_payment" ? (
          <>
            <label className="ampli-rule-editor__field">
              <span className="card-label">Percentual da entrada (%)</span>
              <input
                type="number"
                aria-label="Percentual da entrada"
                aria-describedby={errorId}
                value={bpsToPercentInput(form.downPaymentBps)}
                onChange={(event) => onPatch({
                  downPaymentBps: percentInputToBps(event.target.value),
                })}
              />
            </label>
            <label className="ampli-rule-editor__field">
              <span className="card-label">Entrada em (meses)</span>
              <input
                type="number"
                aria-label="Entrada em"
                min={OFFSET_RANGE.min}
                max={OFFSET_RANGE.max}
                value={numberValue(form.downPaymentOffset)}
                onChange={(event) => onPatch({
                  downPaymentOffset: integerInput(event.target.value),
                })}
              />
            </label>
          </>
        ) : null}
        <label className="ampli-rule-editor__field">
          <span className="card-label">Número de parcelas</span>
          <input
            type="number"
            min="1"
            aria-label="Número de parcelas"
            value={numberValue(form.installments)}
            onChange={(event) => onPatch({ installments: integerInput(event.target.value) })}
          />
        </label>
        <label className="ampli-rule-editor__field">
          <span className="card-label">Primeira parcela em (meses)</span>
          <input
            type="number"
            aria-label="Primeira parcela em"
            min={OFFSET_RANGE.min}
            max={OFFSET_RANGE.max}
            value={numberValue(form.startOffset)}
            onChange={(event) => onPatch({ startOffset: integerInput(event.target.value) })}
          />
        </label>
      </div>
    )}
  </>
);

export default RuleShortcutFields;
